import BaseErrorBoundary from 'personalization-lib/components/shared/errorHandling/boundaries/BaseErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const withModalErrorHandling = (WrappedComponent, {
  onComponentError
} = {}) => props => /*#__PURE__*/_jsx(BaseErrorBoundary, {
  onError: props.onComponentError || onComponentError,
  children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
});
export default withModalErrorHandling;